export function showHide()
{
	$('.show-hide__trigger').on('click', function()
	{
		const parent = $(this).parent();

		if(parent.hasClass('active'))
		{
			hide(this);
		}
		else
		{
			show(this);
		}
	})

	// handle cases that should be open by default
	$('.show-hide--default-show .show-hide__trigger').each((_, trigger) => {
		show(trigger, true);
	});
}


function show(triggerElem, instant = false) {
	const parent = $(triggerElem).parent();
	const grandparent = parent.parent();
	const body = parent.find('.show-hide__body');

	body.slideDown(instant ? 0 : 200);
	parent.attr('aria-hidden', 'false');
	parent.addClass('open');

	setTimeout(() => {
		parent.addClass('active');
	}, instant ? 0 : 100 );

	if(parent.hasClass('feed-filter'))
	{
		if(grandparent.hasClass('home-nav'))
		{
			grandparent.addClass('active');
		}

		let uncle = parent.siblings();
		let cousin = uncle.find('.show-hide__body');

		uncle.removeClass('active');
		uncle.removeClass('open');
		uncle.attr('aria-hidden', 'true');

		setTimeout(() => {
			cousin.slideUp(instant ? 0 : 200);
		}, instant ? 0 : 100 );
	}
}

function hide(triggerElem, instant = false) {
	const parent = $(triggerElem).parent();
	const grandparent = parent.parent();
	const body = parent.find('.show-hide__body');

	parent.removeClass('active');
	parent.removeClass('open');
	parent.attr('aria-hidden', 'true');

	if(grandparent.hasClass('home-nav'))
	{
		grandparent.removeClass('active');
	}

	setTimeout(() => {
		body.slideUp(instant ? 0 : 200);
	}, instant ? 0 : 100 );
}



// WEBPACK FOOTER //
// ./scripts/modules/show-hide.js